import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';
import './hero.css';
import image1 from '../../img/hero/hero.png'; 
import image2 from '../../img/hero/my.svg'; 
import backgroundImage from '../../img/hero/hero-1.png';

const Hero = () => {
  const typedRef = useRef(null);

  useEffect(() => {
    const typedElement = typedRef.current;

    if (typedElement) {
      const typedStrings = typedElement.getAttribute('data-typed-items').split(',');

      if (typedRef.current && typedRef.current._typed) {
        typedRef.current._typed.destroy();
      }

      typedRef.current._typed = new Typed(typedElement, {
        strings: typedStrings,
        typeSpeed: 50, 
        backSpeed: 50, 
        loop: true, 
        showCursor: false 
      });
    }

    return () => {
      if (typedRef.current && typedRef.current._typed) {
        typedRef.current._typed.destroy();
      }
    };
  }, []);

  return (
    <section id="hero" className="hero-section" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="left-container">
          <button className="btn" type="button">
              <strong>Shopify Expert | React JS Developer</strong>
              <div id="container-stars">
                <div id="stars"></div>
              </div>
              <div id="glow">
                <div className="circle"></div>
                <div className="circle"></div>
              </div>
            </button>
            <div className="hero-content">
              <h1 className="hero-title">
                <span className="hero-title-line">Wazir Mubashir Hussain</span>
              </h1>
              <p className="hero-subtitle">
                I'm{' '}
                <span
                  ref={typedRef}
                  className="typed"
                  data-typed-items="React JS Developer , Shopify Developer"
                ></span>
              </p>
            </div>
          </div>
          <div className="right-container">
            <div className="hero-image-container">
              <img src={image1} alt="Your Alt Text" className="hero-image" />
              <img src={image2} alt="Background Image" className="background-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;